import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.checklist.respond');
import { OnInit, OnDestroy, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let WizRoute: any;
declare let wiz: any;

const GRADE_VALUES: any = { a: 10, b: 8, c: 5, d: 2, e: 0 };
const INSPECTION_CATEGORY_WEIGHTS: any = {
    '주요시설': 60,
    '일반시설': 20,
    '부대시설': 20,
};

@Component({
    selector: 'wiz-page-checklist-respond',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.checklist.respond/view.scss */
:host {
  display: block;
  height: 100vh;
  background-color: #F8F9FA;
}

.respond-page {
  font-family: "Pretendard", sans-serif;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.header-container {
  background-color: #FFFFFF;
  padding: 8px 16px;
  border-bottom: 1px solid #E3E3E3;
  flex-shrink: 0;
  z-index: 10;
}

.top-app-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
}
.top-app-bar .nav-btn {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #444746;
  cursor: pointer;
  flex-shrink: 0;
}
.top-app-bar .nav-btn:hover {
  background-color: #F1F3F4;
}
.top-app-bar .nav-btn i {
  font-size: 16px;
}

.header-title-area {
  flex: 1;
  min-width: 0;
}
.header-title-area .header-title {
  font-size: 16px;
  font-weight: 800;
  color: #1F1F1F;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.header-title-area .header-badges {
  display: flex;
  gap: 6px;
  margin-top: 2px;
  flex-wrap: wrap;
}
.header-title-area .badge {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
}
.header-title-area .badge.form-type {
  background-color: #D3E3FD;
  color: #041E49;
}
.header-title-area .badge.facility {
  background-color: #E6F4EA;
  color: #137333;
}
.header-title-area .badge.response-status.submitted {
  background-color: #E6F4EA;
  color: #137333;
}
.header-title-area .badge.response-status.submit-pending {
  background-color: #E8F0FE;
  color: #1A73E8;
}
.header-title-area .badge.response-status.sync-failed {
  background-color: #FCE8E6;
  color: #C5221F;
}
.header-title-area .badge.response-status.draft {
  background-color: #FEF7E0;
  color: #B05E00;
}
.header-title-area .badge.saved {
  background-color: #F1F3F4;
  color: #5F6368;
}
.header-title-area .badge.saved i {
  margin-right: 3px;
  font-size: 9px;
}

.header-actions {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}
.header-actions button {
  height: 36px;
  padding: 0 14px;
  border-radius: 18px;
  border: none;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s;
}
.header-actions button i {
  font-size: 12px;
}
.header-actions .btn-save {
  background: #F1F3F4;
  color: #444746;
}
.header-actions .btn-save:hover {
  background: #E3E3E3;
}
.header-actions .btn-submit {
  background: #0B57D0;
  color: #fff;
}
.header-actions .btn-submit:hover {
  background: #0947a9;
}

.respond-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.status-notice {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-bottom: 1px solid #E8EAED;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
}
.status-notice.sync-failed {
  background: #FCE8E6;
  color: #C5221F;
}
.status-notice i {
  font-size: 14px;
}

.section-nav {
  display: flex;
  gap: 2px;
  padding: 8px 16px;
  background: #FFFFFF;
  border-bottom: 1px solid #E8EAED;
  overflow-x: auto;
  flex-shrink: 0;
}
.section-nav::-webkit-scrollbar {
  display: none;
}

.section-tab {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 8px;
  border: 1px solid transparent;
  background: transparent;
  font-size: 13px;
  font-weight: 600;
  color: #5F6368;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.15s;
}
.section-tab .tab-num {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #E8EAED;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 800;
}
.section-tab.active {
  background: #D3E3FD;
  border-color: #A8C7FA;
  color: #041E49;
}
.section-tab.active .tab-num {
  background: #0B57D0;
  color: #fff;
}
.section-tab:hover:not(.active) {
  background: #F1F3F4;
}

.section-content {
  flex: 1;
  overflow-y: auto;
  padding: 12px 16px;
}

.section-panel {
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
}

.section-header {
  margin-bottom: 12px;
}
.section-header h3 {
  font-size: 17px;
  font-weight: 800;
  color: #1F1F1F;
  margin: 0 0 4px;
}
.section-header p {
  font-size: 13px;
  color: #5F6368;
  margin: 0;
}

.section-multipliers {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: 6px;
  font-size: 12px;
  color: #5F6368;
}
.section-multipliers .mul {
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 700;
}
.section-multipliers .mul.good {
  background: #E6F4EA;
  color: #137333;
}
.section-multipliers .mul.fair {
  background: #FEF7E0;
  color: #B05E00;
}
.section-multipliers .mul.poor {
  background: #FCE8E6;
  color: #C5221F;
}

.inspection-table {
  width: 100%;
}

.table-header, .table-row {
  display: grid;
  gap: 4px;
  align-items: center;
  grid-template-columns: 36px 1fr 1fr 80px 240px;
}

.table-header {
  padding: 8px 4px;
  border-bottom: 2px solid #E8EAED;
}
.table-header div {
  font-size: 11px;
  font-weight: 800;
  color: #5F6368;
  text-align: center;
}
.table-header .th-label {
  text-align: left;
}

.table-row {
  padding: 10px 4px;
  border-bottom: 1px solid #F1F3F4;
}
.table-row:hover {
  background: #FAFBFC;
}
.table-row.not-applicable {
  opacity: 0.4;
}

.td-num {
  text-align: center;
  font-size: 12px;
  color: #9AA0A6;
  font-weight: 700;
}

.td-label {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}
.td-label span {
  font-size: 13px;
  color: #1F1F1F;
  font-weight: 600;
  display: block;
}
.td-label small {
  display: block;
  font-size: 11px;
  color: #9AA0A6;
}

.inspection-table .td-label,
.inspection-table .td-opinion {
  align-self: start;
}

.td-grades {
  display: flex;
  gap: 3px;
  justify-content: center;
  flex-wrap: nowrap;
}

.grade-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid #E0E0E0;
  background: #fff;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
  color: #5F6368;
  text-transform: uppercase;
  transition: all 0.12s;
}
.grade-btn[data-grade=a]:hover:not(:disabled) {
  border-color: #1E8E3E;
  color: #1E8E3E;
}
.grade-btn[data-grade=a].selected {
  background: #1E8E3E;
  color: #fff;
  border-color: #1E8E3E;
}
.grade-btn[data-grade=b]:hover:not(:disabled) {
  border-color: #1A73E8;
  color: #1A73E8;
}
.grade-btn[data-grade=b].selected {
  background: #1A73E8;
  color: #fff;
  border-color: #1A73E8;
}
.grade-btn[data-grade=c]:hover:not(:disabled) {
  border-color: #F9AB00;
  color: #F9AB00;
}
.grade-btn[data-grade=c].selected {
  background: #F9AB00;
  color: #fff;
  border-color: #F9AB00;
}
.grade-btn[data-grade=d]:hover:not(:disabled) {
  border-color: #E8710A;
  color: #E8710A;
}
.grade-btn[data-grade=d].selected {
  background: #E8710A;
  color: #fff;
  border-color: #E8710A;
}
.grade-btn[data-grade=e]:hover:not(:disabled) {
  border-color: #D93025;
  color: #D93025;
}
.grade-btn[data-grade=e].selected {
  background: #D93025;
  color: #fff;
  border-color: #D93025;
}
.grade-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
.grade-btn.na-grade {
  width: auto;
  padding: 0 8px;
  font-size: 11px;
  text-transform: none;
  color: #9AA0A6;
  border-color: #E0E0E0;
}
.grade-btn.na-grade:hover {
  border-color: #9AA0A6;
  color: #5F6368;
}
.grade-btn.na-grade.selected {
  background: #E8EAED;
  color: #1F1F1F;
  border-color: #C4C7C5;
}

.td-opinion {
  display: flex;
  flex-direction: column;
  align-items: stretch !important;
  gap: 8px;
}
.td-opinion input {
  width: 100%;
  border: 1px solid #E0E0E0;
  border-radius: 6px;
  padding: 6px 8px;
  font-size: 12px;
  outline: none;
  background: #fff;
  color: #1F1F1F;
}
.td-opinion input:focus {
  border-color: #0B57D0;
}
.td-opinion input:disabled {
  opacity: 0.3;
}

.td-repair {
  text-align: center;
}

.repair-toggle {
  display: inline-flex;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #E0E0E0;
}

.repair-opt {
  padding: 4px 10px;
  border: none;
  background: #fff;
  font-size: 12px;
  font-weight: 700;
  color: #9AA0A6;
  cursor: pointer;
  transition: all 0.12s;
}
.repair-opt:first-child {
  border-right: 1px solid #E0E0E0;
}
.repair-opt.selected {
  background: #FEF7E0;
  color: #B05E00;
}
.repair-opt:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.sports-table {
  width: 100%;
}

.sports-table .table-header, .sports-table .table-row {
  grid-template-columns: 36px 1fr 60px 180px 60px;
}

.td-points {
  text-align: center;
  font-size: 13px;
  font-weight: 700;
  color: #0B57D0;
}

.td-ratings {
  display: flex;
  gap: 3px;
  justify-content: center;
}

.rating-btn {
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid #E0E0E0;
  background: #fff;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.12s;
}
.rating-btn.good {
  color: #137333;
}
.rating-btn.good.selected {
  background: #E6F4EA;
  border-color: #1E8E3E;
}
.rating-btn.fair {
  color: #B05E00;
}
.rating-btn.fair.selected {
  background: #FEF7E0;
  border-color: #F9AB00;
}
.rating-btn.poor {
  color: #C5221F;
}
.rating-btn.poor.selected {
  background: #FCE8E6;
  border-color: #D93025;
}
.rating-btn:hover {
  transform: scale(1.05);
}

.td-score {
  text-align: center;
  font-size: 13px;
  font-weight: 800;
  color: #1F1F1F;
}

.generic-items {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.generic-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.generic-item .item-label {
  display: block;
  font-size: 13px;
  font-weight: 700;
  color: #1F1F1F;
  margin-bottom: 0;
}
.generic-item .item-label .required-mark {
  color: #D93025;
  margin-left: 2px;
}

.generic-input {
  width: 100%;
  border: 1px solid #E0E0E0;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 13px;
  outline: none;
  background: #fff;
  font-family: inherit;
  color: #1F1F1F;
}
.generic-input:focus {
  border-color: #0B57D0;
}
.generic-input.textarea {
  min-height: 80px;
  resize: vertical;
}

.item-photo-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.item-photo-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 8px;
}

.item-photo-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border: 1px solid #D2E3FC;
  border-radius: 8px;
  background: #EFF3FD;
  color: #0B57D0;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.item-photo-btn:hover {
  background: #E8F0FE;
  border-color: #A8C7FA;
}
.item-photo-btn i {
  font-size: 12px;
}

.item-photo-count {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 0 8px;
  border-radius: 999px;
  background: #F1F3F4;
  font-size: 11px;
  font-weight: 700;
  color: #5F6368;
}

.item-photo-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.item-photo-thumb {
  position: relative;
  width: 72px;
  height: 72px;
  border-radius: 10px;
  overflow: hidden;
  background: #E8EAED;
  border: 1px solid #DADCE0;
}
.item-photo-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.item-photo-remove {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 22px;
  height: 22px;
  border: none;
  border-radius: 50%;
  background: rgba(32, 33, 36, 0.78);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.item-photo-remove i {
  font-size: 11px;
}

.score-panel {
  flex-shrink: 0;
  background: #FFFFFF;
  border-top: 1px solid #E3E3E3;
  padding: 12px 16px;
  overflow-y: auto;
  max-height: 40vh;
}

.score-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  background: #F8F9FA;
  border-radius: 12px;
  margin-bottom: 10px;
}

.score-main {
  display: flex;
  align-items: baseline;
  gap: 4px;
}
.score-main .score-label {
  font-size: 12px;
  color: #5F6368;
  font-weight: 700;
  margin-right: 4px;
}
.score-main .score-value {
  font-size: 28px;
  font-weight: 900;
  color: #1F1F1F;
}
.score-main .score-max {
  font-size: 14px;
  color: #9AA0A6;
  font-weight: 600;
}

.score-percent {
  font-size: 20px;
  font-weight: 800;
  color: #0B57D0;
}

.score-grade {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 900;
}
.score-grade[data-grade=A] {
  background: #E6F4EA;
}
.score-grade[data-grade=A] span {
  color: #137333;
}
.score-grade[data-grade=B] {
  background: #E8F0FE;
}
.score-grade[data-grade=B] span {
  color: #1A73E8;
}
.score-grade[data-grade=C] {
  background: #FEF7E0;
}
.score-grade[data-grade=C] span {
  color: #B05E00;
}
.score-grade[data-grade=D] {
  background: #FCE8E6;
}
.score-grade[data-grade=D] span {
  color: #E8710A;
}
.score-grade[data-grade=E] {
  background: #FCE8E6;
}
.score-grade[data-grade=E] span {
  color: #D93025;
}

.score-categories {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.score-categories .cat-item {
  display: flex;
  gap: 4px;
  align-items: center;
  padding: 4px 10px;
  background: #F1F3F4;
  border-radius: 6px;
  font-size: 12px;
}
.score-categories .cat-title {
  font-weight: 700;
  color: #1F1F1F;
}
.score-categories .cat-avg {
  font-weight: 800;
  color: #0B57D0;
}
.score-categories .cat-count {
  color: #9AA0A6;
}

.meta-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.meta-row {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.meta-row.full {
  grid-column: 1/-1;
}
.meta-row label {
  font-size: 11px;
  font-weight: 700;
  color: #5F6368;
}
.meta-row input, .meta-row select, .meta-row textarea {
  border: 1px solid #E0E0E0;
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 13px;
  outline: none;
  background: #fff;
  font-family: inherit;
  color: #1F1F1F;
}
.meta-row input:focus, .meta-row select:focus, .meta-row textarea:focus {
  border-color: #0B57D0;
}
.meta-row textarea {
  resize: vertical;
  min-height: 60px;
}

.meta-row-triple {
  grid-column: 1/-1;
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.meta-item-sm {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.meta-item-sm:first-child {
  flex: 1;
}
.meta-item-sm label {
  font-size: 11px;
  font-weight: 700;
  color: #5F6368;
}

.auto-grade {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 14px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 900;
  background: #F1F3F4;
  color: #9AA0A6;
}
.auto-grade[data-grade=A] {
  background: #E6F4EA;
}
.auto-grade[data-grade=A] span {
  color: #137333;
}
.auto-grade[data-grade=B] {
  background: #E8F0FE;
}
.auto-grade[data-grade=B] span {
  color: #1A73E8;
}
.auto-grade[data-grade=C] {
  background: #FEF7E0;
}
.auto-grade[data-grade=C] span {
  color: #B05E00;
}
.auto-grade[data-grade=D] {
  background: #FCE8E6;
}
.auto-grade[data-grade=D] span {
  color: #E8710A;
}
.auto-grade[data-grade=E] {
  background: #FCE8E6;
}
.auto-grade[data-grade=E] span {
  color: #D93025;
}

.toggle-group {
  display: inline-flex;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #E0E0E0;
}

.toggle-opt {
  padding: 7px 14px;
  border: none;
  background: #fff;
  font-size: 13px;
  font-weight: 700;
  color: #9AA0A6;
  cursor: pointer;
  transition: all 0.12s;
}
.toggle-opt:first-child {
  border-right: 1px solid #E0E0E0;
}
.toggle-opt.selected {
  background: #0B57D0;
  color: #fff;
}

.loader-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.loader-container p {
  margin-top: 16px;
  font-size: 14px;
  color: #5F6368;
  font-weight: 600;
}

.google-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #E8EAED;
  border-top-color: #0B57D0;
  border-radius: 50%;
  animation: spin 0.9s ease-in-out infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 1024px) {
  .inspection-table .table-header, .inspection-table .table-row {
    grid-template-columns: 30px 1fr 1fr 70px 210px;
  }
  .grade-btn {
    width: 28px;
    height: 28px;
    font-size: 12px;
    border-radius: 6px;
  }
}
@media (max-width: 768px) {
  .inspection-table .table-header, .inspection-table .table-row {
    grid-template-columns: 24px 1fr 1fr 60px 180px;
  }
  .grade-btn {
    width: 24px;
    height: 24px;
    font-size: 11px;
    border-radius: 5px;
  }
  .grade-btn.na-grade {
    font-size: 10px;
    padding: 0 5px;
  }
  .td-opinion input {
    font-size: 11px;
    padding: 4px 6px;
  }
  .item-photo-thumb {
    width: 60px;
    height: 60px;
  }
  .meta-section {
    grid-template-columns: 1fr;
  }
  .meta-row-triple {
    flex-direction: column;
  }
}`],
})
export class PageChecklistRespondComponent implements OnInit, OnDestroy {
    public responseId: string = '';
    public response: any = null;
    public checklist: any = null;
    public facility: any = null;
    public sections: any[] = [];
    public answers: any = {};
    public loading: boolean = true;

    // Inspection score
    public inspectionTotalScore: number = 0;
    public inspectionGrade: string = '';
    public inspectionCategories: any[] = [];

    // Sports score
    public sportsTotalScore: number = 0;
    public sportsMaxScore: number = 0;
    public sportsPercent: number = 0;
    public sportsGrade: string = '';

    // Meta fields
    public safetyGrade: string = '';
    public emergencyInspection: string = '';
    public safetyAction: string = '';
    public overallOpinion: string = '';
    public inspectorName: string = '';
    public inspectionDate: string = '';

    // Auto-save
    private autoSaveTimer: any = null;
    private isDirty: boolean = false;
    private localDraftPersistChain: Promise<void> = Promise.resolve();
    public lastSaved: string = '';

    // Active section
    public activeSectionIndex: number = 0;

    private handlePageHide = () => {
        if (this.isDirty) void this.persistLocalDraft(this.shouldQueueLocalDraft());
    };

    private handleVisibilityChange = () => {
        if (document.visibilityState === 'hidden' && this.isDirty) {
            void this.persistLocalDraft(this.shouldQueueLocalDraft());
        }
    };

    constructor(@Inject( Service)         public service: Service,@Inject( CDR    )         public ref: CDR    ) { }

    public async ngOnInit() {
        await this.service.init(this);
        this.responseId = WizRoute.segment.responseId || '';
        if (!this.responseId) {
            await this.service.href('/checklist');
            return;
        }
        await this.loadResponse();
        window.addEventListener('pagehide', this.handlePageHide);
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }

    public ngOnDestroy() {
        if (this.autoSaveTimer) clearTimeout(this.autoSaveTimer);
        window.removeEventListener('pagehide', this.handlePageHide);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        if (this.isDirty) void this.persistLocalDraft(this.shouldQueueLocalDraft());
    }

    public async loadResponse() {
        this.loading = true;
        await this.service.render();

        try {
            const { code, data } = await wiz.call("load_response", { response_id: this.responseId });
            if (code === 200) {
                this.response = data.response;
                this.checklist = data.checklist;
                this.facility = data.facility;
                this.sections = data.sections || [];
                this.answers = data.answers || {};
                for (const answer of Object.values(this.answers)) {
                    if (answer && typeof answer === 'object' && !Array.isArray((answer as any).photos)) {
                        (answer as any).photos = [];
                    }
                }

                // 서버 제출 완료 또는 로컬 제출 대기 응답이면 결과 페이지로 이동
                if (this.response.status === 'submitted' || this.response.status === 'submit_pending') {
                    await this.service.href(`/checklist/result/${this.responseId}`);
                    return;
                }

                // Load meta
                this.safetyGrade = this.response.safety_grade || '';
                this.emergencyInspection = this.response.emergency_inspection || '';
                this.safetyAction = this.response.safety_action || '';
                this.overallOpinion = this.response.overall_opinion || '';
                this.inspectorName = this.response.inspector_name || '';
                this.inspectionDate = this.response.inspection_date || new Date().toISOString().split('T')[0];

                this.computeScores();
            }
        } catch (e) {
            console.error(e);
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public getAnswer(itemId: string): any {
        if (!this.answers[itemId]) {
            this.answers[itemId] = {
                grade: '',
                not_applicable: false,
                repair_needed: '',
                opinion: '',
                value: null,
                rating: null,
                photos: [],
            };
        }
        if (!Array.isArray(this.answers[itemId].photos)) {
            this.answers[itemId].photos = [];
        }
        return this.answers[itemId];
    }

    public getAnswerPhotos(itemId: string): any[] {
        return this.getAnswer(itemId).photos || [];
    }

    public onAnswerChange(itemId: string) {
        this.isDirty = true;
        this.computeScores();
        void this.persistLocalDraft(this.shouldQueueLocalDraft());
        this.scheduleAutoSave();
        this.service.render();
    }

    public setGrade(itemId: string, grade: string) {
        const answer = this.getAnswer(itemId);
        if (grade === 'na') {
            // 해당없음 선택
            answer.grade = 'na';
            answer.not_applicable = true;
            answer.repair_needed = '';
            answer.opinion = '';
        } else {
            answer.grade = grade;
            answer.not_applicable = false;
        }
        this.onAnswerChange(itemId);
    }

    public setRating(itemId: string, rating: string) {
        const answer = this.getAnswer(itemId);
        answer.rating = rating;
        this.onAnswerChange(itemId);
    }

    public triggerItemPhotoCapture(itemId: string) {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.capture = 'environment';
        input.multiple = true;
        input.onchange = (event: any) => {
            const files = event.target.files;
            if (!files || files.length === 0) return;
            for (let index = 0; index < files.length; index++) {
                this.processItemPhoto(itemId, files[index]);
            }
        };
        input.click();
    }

    private processItemPhoto(itemId: string, file: File) {
        const reader = new FileReader();
        reader.onload = (event: any) => {
            const answer = this.getAnswer(itemId);
            answer.photos.push({
                id: this.generateId(),
                name: file.name,
                data: event.target.result,
                timestamp: new Date().toISOString()
            });
            this.onAnswerChange(itemId);
        };
        reader.readAsDataURL(file);
    }

    public removeItemPhoto(itemId: string, photoId: string) {
        const answer = this.getAnswer(itemId);
        answer.photos = (answer.photos || []).filter((photo: any) => photo.id !== photoId);
        this.onAnswerChange(itemId);
    }

    private generateId(): string {
        return Date.now().toString(36) + Math.random().toString(36).slice(2, 9);
    }

    // ====== Score computation ======
    public computeScores() {
        if (!this.checklist) return;
        if (this.checklist.form_type === 'inspection') {
            this.computeInspectionScore();
        } else if (this.checklist.form_type === 'sports') {
            this.computeSportsScore();
        }
    }

    public computeInspectionScore() {
        const catMap = new Map<string, { sections: any[] }>();
        for (const section of this.sections) {
            const catTitle = section.group_title || section.title;
            if (!catMap.has(catTitle)) catMap.set(catTitle, { sections: [] });
            catMap.get(catTitle)!.sections.push(section);
        }

        const categories: any[] = [];
        for (const [title, data] of catMap.entries()) {
            let sum = 0, answered = 0, itemCount = 0, naCount = 0;
            for (const section of data.sections) {
                for (const item of (section.items || [])) {
                    itemCount++;
                    const answer = this.getAnswer(item.id);
                    if (answer.grade === 'na' || answer.not_applicable) { naCount++; continue; }
                    if (answer.grade && GRADE_VALUES[answer.grade] !== undefined) {
                        sum += GRADE_VALUES[answer.grade];
                        answered++;
                    }
                }
            }
            categories.push({
                title,
                weight: INSPECTION_CATEGORY_WEIGHTS[title] || 0,
                avg: answered > 0 ? Math.round((sum / answered) * 100) / 100 : 0,
                hasData: answered > 0,
                answeredCount: answered,
                totalCount: itemCount,
                naCount,
            });
        }

        this.inspectionCategories = categories;
        const active = categories.filter(c => c.hasData && c.weight > 0);
        const activeSum = active.reduce((s: number, c: any) => s + c.weight, 0);

        let totalScore = 0;
        if (activeSum > 0) {
            for (const cat of active) {
                totalScore += cat.avg * (cat.weight * (100 / activeSum)) / 100;
            }
        }
        this.inspectionTotalScore = Math.round(totalScore * 100) / 100;

        if (this.inspectionTotalScore >= 7) this.inspectionGrade = 'A';
        else if (this.inspectionTotalScore >= 6) this.inspectionGrade = 'B';
        else if (this.inspectionTotalScore >= 5) this.inspectionGrade = 'C';
        else if (this.inspectionTotalScore >= 4) this.inspectionGrade = 'D';
        else this.inspectionGrade = 'E';

        this.safetyGrade = this.inspectionGrade;
    }

    public computeSportsScore() {
        let totalScore = 0;
        let maxScore = 0;

        for (const section of this.sections) {
            for (const item of (section.items || [])) {
                const points = item.points || 0;
                maxScore += points;
                const answer = this.getAnswer(item.id);
                if (answer.rating === 'good') {
                    totalScore += points * (section.good_multiplier ?? 1.0);
                } else if (answer.rating === 'fair') {
                    totalScore += points * (section.fair_multiplier ?? 0.6);
                } else if (answer.rating === 'poor') {
                    totalScore += points * (section.poor_multiplier ?? 0.4);
                }
            }
        }

        this.sportsTotalScore = Math.round(totalScore * 100) / 100;
        this.sportsMaxScore = maxScore;
        this.sportsPercent = maxScore > 0 ? Math.round((totalScore / maxScore) * 10000) / 100 : 0;

        if (this.sportsPercent >= 95) this.sportsGrade = 'A';
        else if (this.sportsPercent >= 85) this.sportsGrade = 'B';
        else if (this.sportsPercent >= 65) this.sportsGrade = 'C';
        else this.sportsGrade = 'D';

        this.safetyGrade = this.sportsGrade;
    }

    public getItemScore(item: any, section: any): number {
        const answer = this.getAnswer(item.id);
        const points = item.points || 0;
        if (answer.rating === 'good') return Math.round(points * (section.good_multiplier ?? 1.0) * 100) / 100;
        if (answer.rating === 'fair') return Math.round(points * (section.fair_multiplier ?? 0.6) * 100) / 100;
        if (answer.rating === 'poor') return Math.round(points * (section.poor_multiplier ?? 0.4) * 100) / 100;
        return 0;
    }

    // ====== Auto-save ======
    private scheduleAutoSave() {
        if (this.autoSaveTimer) clearTimeout(this.autoSaveTimer);
        this.autoSaveTimer = setTimeout(() => {
            this.save(true);
        }, 3000);
    }

    private buildRequestPayload(meta: any): any {
        return {
            response_id: this.responseId,
            answers: JSON.stringify(this.answers),
            meta: JSON.stringify(meta)
        };
    }

    private checklistTimestamp(): string {
        return new Date().toISOString().slice(0, 19).replace('T', ' ');
    }

    private checklistResponseKey(): string {
        return `checklist_response:${this.responseId}`;
    }

    private checklistResultKey(): string {
        return `checklist_result:${this.responseId}`;
    }

    private checklistMappingKey(mappingId: string): string {
        return `checklist_mapping_response:${mappingId}`;
    }

    private shouldQueueLocalDraft(): boolean {
        try {
            if (wiz.offline?.isOffline && wiz.offline.isOffline()) return true;
        } catch { }
        return typeof navigator !== 'undefined' && navigator.onLine === false;
    }

    private countAttachedPhotos(): number {
        let count = 0;
        for (const answer of Object.values(this.answers || {})) {
            const photos = answer && typeof answer === 'object' ? (answer as any).photos : null;
            if (Array.isArray(photos)) count += photos.length;
        }
        return count;
    }

    private getPhotoSyncStatus(queueSync: boolean): string {
        if (this.countAttachedPhotos() === 0) return 'none';
        return queueSync ? 'pending' : 'local';
    }

    private async persistLocalDraft(queueSync: boolean = false, synced: boolean = false): Promise<void> {
        const run = async () => {
            if (!this.responseId || !this.response || !wiz.offline?.storage) return;

            const meta = this.buildMeta();
            const photoCount = this.countAttachedPhotos();
            const response = {
                ...this.response,
                ...meta,
                id: this.responseId,
                status: this.response.status === 'submit_pending' ? 'submit_pending' : 'draft',
                sync_source: synced ? 'server' : 'local',
                sync_status: synced ? 'synced' : (queueSync ? 'pending' : (this.response.sync_status || 'draft')),
                sync_error: '',
                photo_count: photoCount,
                photo_sync_status: synced ? (photoCount > 0 ? 'synced' : 'none') : this.getPhotoSyncStatus(queueSync),
                updated: this.checklistTimestamp()
            };

            const cached = await wiz.offline.storage.getMeta(this.checklistResponseKey());
            const aggregate = {
                ...(cached || {}),
                response,
                checklist: this.checklist,
                facility: this.facility,
                sections: this.sections,
                answers: this.answers
            };

            await wiz.offline.storage.setMeta(this.checklistResponseKey(), aggregate);
            await wiz.offline.storage.setMeta(this.checklistResultKey(), aggregate);
            if (response.mapping_id) {
                await wiz.offline.storage.setMeta(this.checklistMappingKey(response.mapping_id), {
                    response_id: this.responseId,
                    status: response.status,
                    cached_at: Date.now()
                });
            }

            if (queueSync && wiz.offline?.sync?.queueWrite) {
                await wiz.offline.sync.queueWrite({
                    entity_type: 'checklist_response',
                    entity_id: this.responseId,
                    action: 'save_response',
                    payload: this.buildRequestPayload(meta),
                    api_endpoint: wiz.url('save_response'),
                    operation_id: `checklist_response:${this.responseId}:save_response`
                });
            }
        };

        this.localDraftPersistChain = this.localDraftPersistChain.then(run, run);
        return this.localDraftPersistChain.catch((e) => console.warn('[ChecklistRespond] Local draft persist failed', e));
    }

    private getResponseMessage(result: any): string {
        if (result?.message) return result.message;
        if (result?.data?.message) return result.data.message;
        if (typeof result?.data === 'string') return result.data;
        return '';
    }

    private async postResponseAction(action: string, meta: any): Promise<{ code: number; data: any; message: string }> {
        const result = await wiz.call(action, this.buildRequestPayload(meta), { timeout: 10000 });
        return {
            code: result?.code || 500,
            data: result?.data,
            message: this.getResponseMessage(result)
        };
    }

    public async save(silent: boolean = false) {
        let loadingVisible = !silent;
        if (loadingVisible) await this.service.loading.show();

        const hideLoading = async () => {
            if (loadingVisible) {
                await this.service.loading.hide();
                loadingVisible = false;
            }
        };

        const meta = this.buildMeta();
        try {
            const { code, data, message } = await this.postResponseAction('save_response', meta);
            if (code === 200) {
                if (data?.response) this.response = data.response;
                await this.persistLocalDraft(false, true);
                this.isDirty = false;
                this.lastSaved = new Date().toLocaleTimeString('ko-KR');
                if (!silent) {
                    await hideLoading();
                    await this.service.alert.show({
                        title: '저장 완료', message: '임시 저장되었습니다.',
                        status: 'success', action: '확인', cancel: false
                    });
                }
            } else if (!silent) {
                await hideLoading();
                await this.service.alert.show({
                    title: '저장 실패', message: message || '임시 저장 중 오류가 발생했습니다.',
                    status: 'error', action: '확인', cancel: false
                });
            }
        } catch (e) {
            console.error(e);
            if (!silent) {
                await hideLoading();
                await this.service.alert.show({
                    title: '저장 실패', message: '임시 저장 중 오류가 발생했습니다.',
                    status: 'error', action: '확인', cancel: false
                });
            }
        } finally {
            await hideLoading();
            await this.service.render();
        }
    }

    public async submit() {
        const confirmed = await this.service.alert.show({
            title: '제출 확인',
            message: '제출하면 수정이 불가합니다. 제출하시겠습니까?',
            action: '제출',
            actionBtn: 'primary',
            cancel: '취소'
        });
        if (!confirmed) return;

        let loadingVisible = true;
        await this.service.loading.show();
        const hideLoading = async () => {
            if (loadingVisible) {
                await this.service.loading.hide();
                loadingVisible = false;
            }
        };

        const meta = this.buildMeta();

        try {
            const { code, data, message } = await this.postResponseAction('submit_response', meta);
            if (code === 200) {
                const status = data?.status || data?.response?.status || '';
                const isLocalPending = status === 'submit_pending' || data?.saved === 'local';
                await hideLoading();
                await this.service.alert.show({
                    title: isLocalPending ? '제출 동기화 대기' : '제출 완료',
                    message: isLocalPending
                        ? (message || '서버 제출 완료 전까지는 제출 동기화 대기 상태로 표시됩니다.')
                        : '체크리스트가 서버에 제출되었습니다.',
                    status: isLocalPending ? 'warning' : 'success',
                    action: '확인',
                    cancel: false
                });
                await this.service.href(`/checklist/result/${this.responseId}`);
            } else {
                await hideLoading();
                await this.service.alert.show({
                    title: '제출 실패', message: message || '체크리스트 제출 중 오류가 발생했습니다.',
                    status: 'error', action: '확인', cancel: false
                });
            }
        } catch (e) {
            console.error(e);
            await hideLoading();
            await this.service.alert.show({
                title: '제출 실패', message: '체크리스트 제출 중 오류가 발생했습니다.',
                status: 'error', action: '확인', cancel: false
            });
        } finally {
            await hideLoading();
        }
    }

    private buildMeta() {
        const meta: any = {
            inspector_name: this.inspectorName,
            inspection_date: this.inspectionDate,
            overall_opinion: this.overallOpinion,
            safety_grade: this.safetyGrade,
            emergency_inspection: this.emergencyInspection,
            safety_action: this.safetyAction,
        };

        if (this.checklist?.form_type === 'inspection') {
            meta.total_score = this.inspectionTotalScore;
            meta.max_score = 10;
        } else if (this.checklist?.form_type === 'sports') {
            meta.total_score = this.sportsTotalScore;
            meta.max_score = this.sportsMaxScore;
        }

        return meta;
    }

    public setActiveSection(idx: number) {
        this.activeSectionIndex = idx;
        this.service.render();
    }

    public getGradeLabel(grade: string): string {
        const labels: any = { a: 'a (양호)', b: 'b (경미)', c: 'c (보통)', d: 'd (미흡)', e: 'e (불량)', na: '해당없음' };
        return labels[grade] || grade;
    }

    public getGradeColor(grade: string): string {
        const colors: any = { a: '#1E8E3E', b: '#1A73E8', c: '#F9AB00', d: '#E8710A', e: '#D93025', na: '#9AA0A6' };
        return colors[grade] || '#5F6368';
    }

    public getFormTypeLabel(): string {
        if (!this.checklist) return '';
        if (this.checklist.form_type === 'inspection') return '정기안전점검';
        if (this.checklist.form_type === 'sports') return '체육시설점검';
        return '일반 체크리스트';
    }

    public getResponseStatusLabel(): string {
        const status = this.response?.status;
        if (status === 'submitted') return '제출 완료';
        if (status === 'submit_pending') return '제출 동기화 대기';
        if (status === 'sync_failed') return '제출 동기화 실패';
        return '작성 중';
    }

    public getResponseStatusClass(): string {
        const status = this.response?.status;
        if (status === 'submitted') return 'submitted';
        if (status === 'submit_pending') return 'submit-pending';
        if (status === 'sync_failed') return 'sync-failed';
        return 'draft';
    }

    public hasResponseStatusNotice(): boolean {
        return this.response?.status === 'sync_failed';
    }

    public getResponseStatusMessage(): string {
        if (this.response?.status === 'sync_failed') {
            return this.response.sync_error
                ? `서버 반영에 실패했습니다. 수정 후 다시 제출하세요. 사유: ${this.response.sync_error}`
                : '서버 반영에 실패했습니다. 수정 후 다시 제출하세요.';
        }
        return '';
    }

    public async goBack() {
        if (this.isDirty) {
            const confirmed = await this.service.alert.show({
                title: '저장되지 않은 변경사항',
                message: '저장하지 않고 나가시겠습니까?',
                action: '나가기',
                actionBtn: 'danger',
                cancel: '취소'
            });
            if (!confirmed) return;
        }
        window.history.back();
    }
}

export default PageChecklistRespondComponent;